export default { BackendClient: 'SERVICE_BACKEND_CLIENT',
                 Payment: 'SERVICE_PAYMENT_CLIENT',
                 Sockets: 'SERVICE_SOCKETS_CLIENT',
                 Imports: 'SERVICE_IMPORTS_CLIENT',
                 Public: 'SERVICE_PUBLIC_API_CLIENT',
                 AuthClient: 'SERVICE_AUTH_CLIENT'
                };
